
import * as React from 'react'
import { useState } from 'react'
import { styled } from '../../../../shared/styled-components'
import { inject } from 'mobx-react'
import { APIService } from '../../../../shared/APIService'
import { OfficeInstance } from '../../../../models/Office'
import { Utils } from '../../../../shared/Utils'

interface IProps {
  api?: APIService
  office: OfficeInstance
  onClose?: () => any
}

export const QuestionForm = inject('api')(({ api, office }: IProps) => {
  const [sending, setSending] = useState(false)
  const [sent, setSent] = useState(false)
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [telephone, setTelephone] = useState('')
  const [message, setMessage] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSending(true)

    const data = { name, email, telephone, message }
    try {
      await api!.sendMail(office.id, data)
      setSent(true)
    } catch (e) {
      console.error(e)
      alert('Beim Versand Ihrer Mail ist ein Fehler aufgetreten. Bitte kontaktieren Sie uns über info@implacheck.de.')
    }
    setSending(false)
  }

  return (
    <Container>
      <Head>
        <Headline>Persönliche Frage stellen</Headline>
        <SubHeadline>Stellen Sie Ihre Frage an unser Spezialisten-Netzwerk</SubHeadline>
      </Head>
      {sent ? (
        <SentMessage>
          Vielen Dank für Ihre Nachricht! Einer unser Spezialisten wird sich in Kürze bei Ihnen melden.
        </SentMessage>
      ) : (
        <Form onSubmit={handleSubmit}>
          <Input type="text" name="name" placeholder="Name" onChange={(e) => setName(e.target.value)} required />
          <Input
            type="email"
            name="email"
            placeholder="E-Mail-Adresse"
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <Input
            type="tel"
            name="telephone"
            placeholder="Telefonnummer"
            onChange={(e) => setTelephone(e.target.value)}
          />
          <TextArea
            rows="4"
            name="message"
            placeholder="Ihre Frage"
            onChange={(e) => setMessage(e.target.value)}
            required
          />

          <Bottom>
            <SubmitButtonContainer>
              <SubmitButton disabled={sending}>{sending ? 'Wird gesendet...' : 'Frage absenden'}</SubmitButton>
            </SubmitButtonContainer>
            <Disclaimer>
              Durch das Absenden des Formulars akzeptieren Sie unsere{' '}
              <PrivacyLink href="https://implacheck.de/datenschutz/">Datenschutzerklärung</PrivacyLink>.
            </Disclaimer>
          </Bottom>
        </Form>
      )}
    </Container>
  )
})

const Container = styled.div`
  margin-bottom: 3rem;
  @media (max-width: 950px) {
    padding: 20px;
  }
  @media print { 
  display: none;
  }
`

const Head = styled.div`
  margin-bottom: 2rem;
`

const Headline = styled.h3`
  font-size: 20px;
`

const SubHeadline = styled.div`
  color: ${(props) => props.theme.greenColor};
  font-size: 11px;
`

const Form = styled.form`
  display: flex;
  flex-direction: column;
`

const Input = styled.input`
  border: 2px solid ${(props) => props.theme.blueColor};
  padding: 8px;
  border-radius: 3px;
  margin-bottom: 1rem;
  margin-right: 25px;  
  background-image: url(${Utils.getAssetPath('https://implacheck.de/img/form-bg-implantatkostenrechner.jpg')});
`

const TextArea = styled.textarea`
  border: 2px solid ${(props) => props.theme.blueColor};
  padding: 8px;
  border-radius: 3px;
  margin-right: 25px;
  background-image: url(${Utils.getAssetPath('https://implacheck.de/img/form-bg-implantatkostenrechner.jpg')});
`

const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 1rem;
`

const SubmitButton = styled.button`
  width: 90%;
  background-color: ${(props) => props.theme.blueColor};
  padding: 16px 20px;
  border-radius: 3px;
  color: white;
  border: 0;
  cursor: pointer; 
`

const Disclaimer = styled.div`
  font-size: 10px;
  padding-right: 25px;
`

const PrivacyLink = styled.a`
  color: ${(props) => props.theme.greenColor};
`

const SubmitButtonContainer = styled.div`
  flex: 0 0 60%;
`

const SentMessage = styled.div`
  text-align: center;
`
